import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {UserService} from '../../services/user/user.service';
import {AlertService} from '../../services/alert/alert.service';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.css']
})
export class ForgetPasswordComponent implements OnInit {
  loginId: any;
  email: any;

  constructor(private router: Router,
              private userService: UserService,
              private alerts: AlertService)
  { }

  ngOnInit() {
  }

  onSubmit() {
    let body: any = {}
    this.alerts.loading();
    body.loginId = this.loginId;
    body.email = this.email;

    this.userService.recoverPassword(body).subscribe(
      (data: any) => {

        if(data.status){
          this.alerts.closeAlert();
          this.alerts.showSuccess(data.message)
            .then((result:any)=>{
              if (result.value){
                this.router.navigate(['/login'])
              }
            });
        }
        else this.alerts.showError(data.message);

      },
      (error: any) => {
        this.alerts.showError();
      }
    );

  }
}
